// OrganizationContext.js
import React, { createContext, useContext } from 'react';

const OrganizationContext = createContext();

export const OrganizationProvider = ({ children, org }) => {
  return (
    <OrganizationContext.Provider value={org}>
      {children}
    </OrganizationContext.Provider>
  );
};

export const useOrganization = () => useContext(OrganizationContext);